import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import Products from './components/Products';
import ContactPage from './components/ContactPage';
import ServicesPage from './pages/ServicesPage';
import OurWorkPage from './pages/OurWorkPage';
import ConsultingPage from './pages/ConsultingPage';
import InstallationPage from './pages/InstallationPage';
import TrainingPage from './pages/TrainingPage';
import MaintenancePage from './pages/MaintenancePage';
import DemosPage from './pages/DemosPage';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import ReviewPage from './pages/ReviewPage';
import AboutPage from './pages/AboutPage';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <a href="#main-content" className="skip-link">Skip to main content</a>
          <ScrollToTop />
          <Header />
          <main id="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/consulting" element={<ConsultingPage />} />
              <Route path="/services/demos" element={<DemosPage />} />
              <Route path="/services/installation" element={<InstallationPage />} />
              <Route path="/services/training" element={<TrainingPage />} />
              <Route path="/services/maintenance" element={<MaintenancePage />} />
              <Route path="/work" element={<OurWorkPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/reviews" element={<ReviewPage />} />
              <Route path="*" element={
                <div style={{ textAlign: 'center', padding: '8rem 2rem' }}>
                  <h1 style={{ fontSize: '3rem', color: 'var(--color-text)', marginBottom: '1rem' }}>404</h1>
                  <p style={{ color: 'var(--color-text-muted)', fontSize: '1.1rem', marginBottom: '2rem' }}>The page you're looking for doesn't exist.</p>
                  <Link to="/" style={{ background: 'var(--color-primary)', color: 'white', padding: '0.85rem 2.25rem', borderRadius: '50px', fontWeight: 600, textDecoration: 'none' }}>Go Home</Link>
                </div>
              } />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;